/**
 * Generated from syncly-creator-spec/open-api/campaign.openapi.yaml by scripts/openapi-converter.
 * Do not edit this file directly.
 */

import { socialApiClient } from '@/shared/api-client/social-api-client';
import z from 'zod';
import { campaignAnalysisHistoryResponseSchema } from '../campaign-schema';

export const listCampaignAnalysesPathSchema = z.object({
  campaignId: z.string(),
});

export const listCampaignAnalysesQuerySchema = z.object({
  cursor: z.string().optional(),
});

export const listCampaignAnalysesOperationResponseSchema =
  campaignAnalysisHistoryResponseSchema;

export type ListCampaignAnalysesInput = {
  path: z.input<typeof listCampaignAnalysesPathSchema>;
  query?: z.input<typeof listCampaignAnalysesQuerySchema>;
  signal?: AbortSignal;
};

export async function listCampaignAnalyses({
  path,
  query,
  signal,
}: ListCampaignAnalysesInput): Promise<
  z.infer<typeof listCampaignAnalysesOperationResponseSchema>
> {
  const parsedPath = listCampaignAnalysesPathSchema.parse(path);
  const parsedQuery = listCampaignAnalysesQuerySchema.parse(query ?? {});

  const response = await socialApiClient.get(
    `campaigns/${parsedPath.campaignId}/analyses`,
    {
      signal,
      searchParams: parsedQuery,
    },
  );
  return listCampaignAnalysesOperationResponseSchema.parse(
    await response.json(),
  );
}
